<template>
  <de-layout-content>

    <div class="pad-b20">
      <div class="bl_title">问卷管理</div>

      <el-dropdown @command="newTemplate">
        <el-button type="primary" icon="el-icon-circle-plus-outline">新增问卷</el-button>
        <el-dropdown-menu slot="dropdown" class="baseDropdownMenu">
          <el-dropdown-item command="a">模板创建</el-dropdown-item>
          <el-dropdown-item command="b">空白问卷</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

    </div>

    <!-- 查询问卷 -->
    <el-form :model="form" ref="queryForm" :inline="true" class="ant-advanced-search-form">
      <el-form-item label="问卷标题" prop="templateName">
        <el-input v-model="form.templateName" placeholder="请输入问卷标题" clearable @keyup.enter.native="handleQuery" />
      </el-form-item>

      <el-form-item label="问卷类型" prop="queType">
        <el-select v-model="form.queType" placeholder="请选择问卷类型" clearable :popper-append-to-body="true">
          <el-option  v-for="(item, index) in queTypeArr" :key="index" :label="item.name"
            :value="item.id" />
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="btnOperation('search')">查询</el-button>
        <el-button icon="el-icon-refresh" @click="btnOperation('reload')">重置</el-button>
      </el-form-item>
    </el-form>


    <!-- <a-form layout="inline" autocomplete="off" :model="form" name="field">
        <a-form-item label="问卷标题" class="width-normal">
          <a-input v-model:value="form.templateName" placeholder="请输入问卷标题" allowClear />
        </a-form-item>
        <a-form-item class="width-normal" label="问卷类型">
          <a-select v-model:value="form.queType" placeholder="请选择问卷类型" style="width: 200px;" :options="queTypeArr"
            allowClear></a-select>
        </a-form-item>

        <a-form-item class="width-small">
          <a-space :size="8">
            <a-button type="primary" @click="btnOperation('search')"><template #icon>
                <SearchOutlined />
              </template>查询</a-button>
            <a-button @click="btnOperation('reload')"><template #icon>
                <ReloadOutlined />
              </template>重置</a-button>
          </a-space>
        </a-form-item>
      </a-form> -->

    <!-- 数据列表 -->
    <div>
      <!-- 数据列表 -->
      <el-table element-loading-text="加载中" :data="dataSource" @selection-change="handleSelectionChange">
        <el-table-column label="序号" align="center" type="index" />
        <el-table-column label="问卷类型" align="center" prop="queType">
          <template slot-scope="scope">
            {{ scope.row.queType }}
            <!-- <span v-if="scope.row.queType == 1">日常</span>
            <span v-else-if="scope.row.queType == 2">cctai</span>
            <span v-else-if="scope.row.queType == 3">tmti</span>
            <span v-else>-</span> -->
          </template>
        </el-table-column>
        <el-table-column label="问卷标题" align="center" prop="templateName" />
        <el-table-column label="状态" align="center" prop="isPull">
          <template slot-scope="scope">
            <span v-if="scope.row.isPull == 1">未发布</span>
            <span v-else-if="scope.row.isPull == 2">已发布</span>
            <span v-else>—</span>
          </template>
        </el-table-column>
        <el-table-column label="添加人" align="center" prop="createBy" />
        <el-table-column label="添加时间" align="center" prop="createTime" width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime | timestampFormatDate }}</span>
            <!-- {{ scope.row.createTime ? moment(scope.row.createTime).format("yyyy-MM-DD HH:mm:ss") : "" }} -->
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right" width="280">
          <template slot-scope="scope">
            <div class="tableTdControl">
              <el-button size="mini" plain type="primary" @click="setTemplate(scope.row, 1)"
                v-if="scope.row.isPull == 1">编辑</el-button>
              <el-button size="mini" plain type="danger" @click="baseBtn(scope.row, 1)">删除</el-button>
              <el-button size="mini" plain type="primary" @click="previewTemplate(scope.row, 1)">预览</el-button>
              <el-button size="mini" plain type="success" @click="baseBtn(scope.row, 2)"
                v-if="scope.row.isPull == 1">发布</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total > 0" :total="total" :page.sync="form.pageNum" :limit.sync="form.pageSize"
        @pagination="getList" />
    </div>

    <!-- 问卷模版创建 -->
    <el-dialog title="问卷模板创建" :visible.sync="queTemplateDialog" width="800px" :before-close="queTemplateClose"
      custom-class="queTemplateDialog">
      <el-form ref="queTemplateForm" :rules="queTemplateRules" :model="queTemplateForm" label-width="80px">

        <el-form-item label="问卷类型" class="typeElForm" prop="queType">
          <el-select v-model:value="queTemplateForm.queType" placeholder="请选择问卷类型" clearable>
            <el-option v-for="(item, index) in queTypeArr" :key="index" :label="item.name" :value="item.id" />
          </el-select>
          <div class="typeMesgBtn" @click="typeMsgBtn">类型管理</div>
        </el-form-item>

        <el-form-item label="问卷标题" prop="templateName">
          <el-input v-model="queTemplateForm.templateName" placeholder="请输入问卷标题" clearable></el-input>
        </el-form-item>
      </el-form>
      <div class="mainTemplate">
        <div class="leftTemp">
          <div class="seach">
            <el-input v-model="tempSeachVal" placeholder="请输入关键词" prefix-icon="el-icon-search" clearable></el-input>
          </div>
          <div class="conTemp">
            <el-tree class="filter-tree" :data="newTempArr" :props="defaultProps" default-expand-all
              :highlight-current="true" @node-click="treeTempSelect" ref="tree">
            </el-tree>
          </div>
        </div>
        <div class="rightTemp">
          <img :src="newTempImg" alt="" v-if="newTempImg">
          <el-empty v-else :image-size="125" description="请在左侧选择数据" :image="image" />
        </div>
      </div>
      <div slot="footer" class="dialog-footer dialogBoredTop">
        <el-button @click="queTemplateDialog = false">取 消</el-button>
        <el-button type="primary" @click="queTemplateSave">保 存</el-button>
      </div>
    </el-dialog>

    <!-- 新建问卷类型 -->
    <el-dialog title="新建问卷类型" :visible.sync="queTypeDialog" width="600px" :before-close="queTypeClose"
      custom-class="queTemplateDialog">
      <el-form ref="queTypeForm" :model="queTypeForm" :rules="tempTypeRules" label-width="100px">
        <el-form-item label="类型名称" prop="name">
          <el-input v-model="queTypeForm.name" placeholder="请输入类型名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="关联档案分类" prop="type">
          <el-select v-model="queTypeForm.type" placeholder="请选择关联档案分类" clearable>
            <el-option v-for="(item, index) in archivesClassArr" :key="item.name" :label="item.name" :value="item.name" />
          </el-select>
          <div class="newLine">如需在某个分类下展示，则需要选择分类；如不关联分类展示，则不需要选择</div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer dialogBoredTop">
        <el-button @click="queTypeDialog = false">取 消</el-button>
        <el-button type="primary" @click="queTypeSave">保 存</el-button>
      </div>
    </el-dialog>

    <!-- 确认提示 -->
    <el-dialog title="提示" :visible.sync="dialogVisibleConfPrompt" width="30%">
      <span>{{ confTxt }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleConfPrompt = false">取 消</el-button>
        <el-button type="primary" @click="confPromptBtn">确 定</el-button>
      </span>
    </el-dialog>

  </de-layout-content>
</template>

<script>
import moment from "moment";
import * as API_Ques from "@/api/dataAccess/questionnaire";
import axios from 'axios'
let Num = 1;
export default {
  data() {
    return {
      image: require('@/assets/None_Select_ds.png'),
      id: null,
      form: {
        templateName: '',
        queType: undefined,
        pageSize: 10,
        pageNum: 1,
      },
      dataSource: [],

      //数据分页参数
      total: 0,

      // 确认提示
      dialogVisibleConfPrompt: false,
      confTxt: '',
      baseType: null,

      // 问卷模板创建
      tempSeachVal: '',
      queTemplateDialog: false,
      newTempArr: [], //问卷模板列表
      newTempImg: '', //模版图片
      defaultProps: {
        label: 'templateName',
      },
      queTemplateRules: {
        queType: [
          { required: true, message: '请选择问卷类型', trigger: 'change' },
        ],
        templateName: [
          { required: true, message: '请输入问卷名称', trigger: 'blur' },
        ],
      },
      queTemplateForm: {
        queType: null,
        templateName: '',
      },
      queTypeArr: [],
      archivesClassArr: [],

      // 问卷模板创建
      queTypeDialog: false,
      queTypeForm: {
        name: '',
        queType: '',
      },
      tempTypeRules: {
        name: [
          { required: true, message: '请输入类型名称', trigger: 'blur' },
        ],
      }
    };
  },
  watch: {
    tempSeachVal(val) {
      this.$refs.tree.filter(val);
    }
  },
  methods: {

    // 展示确认删除&发布弹窗
    baseBtn(e, i) {
      this.baseType = i
      this.baseData = e
      this.dialogVisibleConfPrompt = true
      if (i == 1) {
        this.confTxt = '确认要删除“' + this.baseData.templateName + '”数据？'
      } else {
        this.confTxt = '确认要发布“' + this.baseData.templateName + '”数据？'
      }
    },

    // 弹窗确认发布/删除
    confPromptBtn() {
      if (this.baseType == 1) {
        // 删除
        const params = {
          ids: [this.baseData.id],
        };
        API_Ques.templateDel(params).then(res => {
          if (res.code == 200) {
            this.dialogVisibleConfPrompt = false
            this.$message.success("删除成功");
            if (this.form.pageNum > 1 && this.dataSource.length == 1) {
              this.form.pageNum--;
            }
            this.reflash();
          }
        })
      } else {
        // 发布
        const params = {
          id: this.baseData.id,
          ispull: 2
        };
        API_Ques.queManagementisPull(params).then(res => {
          if (res.code == 200) {
            this.dialogVisibleConfPrompt = false
            this.$message.success("发布成功");
            if (this.form.pageNum > 1 && this.dataSource.length == 1) {
              this.form.pageNum--;
            }
            this.reflash();
          }
        })
      }
    },


    // 新增问卷下拉-start
    newTemplate(e) {
      if (e == 'a') {
        this.getListTemp()
        this.queTemplateDialog = true
      } else {
        this.$router.push({
          name: "quesTemplateEdit",
          query: {
            enter: 1
          },
        });
      }
    },

    // 问卷模板创建
    queTemplateClose() {
      this.queTemplateDialog = false
    },

    // 问卷模板创建-保存
    queTemplateSave() {
      this.$refs["queTemplateForm"].validate((valid) => {
        if (valid) {
          if (this.templateManagementId && this.newTempImg) {
            const params = {
              queType: this.queTemplateForm.queType,
              templateName: this.queTemplateForm.templateName,
              templateImg: this.newTempImg,
              templateManagementId: this.templateManagementId
            }
            const loading = this.$loading({
              lock: true,
              text: 'Loading',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
            API_Ques.templateMsgAdd(params).then(res => {
              if (res.code == 200) {
                this.queTemplateDialog = false
                this.$message({
                  message: "添加成功",
                  type: "success",
                });
                // this.form.pageNum = 1
                this.getList()
                loading.close()
                // this.getQueTypeArr()
              }
            })
          } else {
            this.$message({
              message: "请点击上方左侧选择模板",
              type: "error",
            });
          }
        } else {
          this.$message({
            message: "填写数据不全或数据有误",
            type: "error",
          });
          return false;
        }
      });
    },


    switchNewTemp(e) {
      this.newTempImg = e.templateImg
    },

    // filterNode(value, data) {
    //   if (!value) return true;
    //   return data.templateName.indexOf(value) !== -1;
    // },

    treeTempSelect(e) {
      if (e.id) {
        this.newTempImg = e.templateImg
        this.templateManagementId = e.id
      } else {
        this.newTempImg = ''
        this.templateManagementId = null
      }
    },

    // 获取问卷模板列表
    getListTemp() {
      API_Ques.findQueTemplate().then(res => {
        if (res.code == 200) {
          const parentArr = [
            {
              templateName: '我创建的',
              children: [],
              disabled: true
            },
            {
              templateName: '系统默认',
              children: [],
              disabled: true
            },
          ]
          parentArr.forEach((ele, i) => {
            if (i == 0) {
              ele.children = res.data.queTemplateManagementVoList.length > 0 ? res.data.queTemplateManagementVoList : []
            } else if (i == 1) {
              ele.children = res.data.queTemplateManagementVoSysList.length > 0 ? res.data.queTemplateManagementVoSysList : []
            }
          });
          this.newTempArr = parentArr
        }
      })
    },
    // 新增问卷下拉-end

    // 新建问卷类型-start
    typeMsgBtn() {
      this.getByKey()
      this.queTypeForm = {
        name: '',
        type: ''
      }
      this.queTypeDialog = true
    },

    // 获取关联档案分类
    getByKey() {
      const params = {
        key: 'QUE_TYPE_INFO',
      };
      API_Ques.sportsGetByKey(params).then(res => {
        if (res.code == 200) {
          const jsonData = JSON.parse(decodeURIComponent(res.data))
          this.archivesClassArr = jsonData.length > 0 ? jsonData : []
        }
      })
    },

    // 新建问卷类型-保存
    queTypeSave() {
      this.$refs["queTypeForm"].validate((valid) => {
        if (valid) {
          const params = {
            name: this.queTypeForm.name,
            type: this.queTypeForm.type ? this.queTypeForm.type : ''
          }
          API_Ques.addQueType(params).then(res => {
            if (res.code == 200) {
              this.queTypeDialog = false
              this.$message({
                message: "添加成功",
                type: "success",
              });
              this.getQueTypeArr()
            }
          })
        } else {
          this.$message({
            message: "填写数据不全或数据有误",
            type: "error",
          });
          return false;
        }
      });
    },

    // 新建问卷类型-end

    // 获取问卷类型
    getQueTypeArr() {
      API_Ques.getQueTypeList().then(res => {
        if (res.code == 200) {
          if (res.data.length > 0) {
            this.queTypeArr = res.data
            this.queTypeArr.forEach((ele, i) => {
              ele.label = ele.name
              ele.value = ele.id
            });
          } else {
            this.queTypeArr = []
          }
          // this.queTypeArr = res.data.length > 0 ? res.data : []
        }
      })
    },

    // 删除数据
    delData(row) {
      const params = {
        ids: [row.id],
      };
      API_Ques.templateDel(params).then(res => {
        if (res.code == 200) {
          this.$message.success("删除成功");
          if (this.form.pageNum > 1 && this.dataSource.length == 1) {
            this.form.pageNum--;
          }
          this.reflash();
        }
      })
    },
    tableChange(pagination) {
      this.pagination = pagination;
      this.reflash();
    },

    // 查询列表
    getList() {
      // return new Promise((resolve, reject) => {
      const params = this.form
      API_Ques.templateListManage(params).then(res => {
        if (res.code == 200) {
          this.total = res.data.total
          this.dataSource = res.data.list
        }
      })
    },

    reset(form, otherReset) {
      let keys = otherReset ? Object.keys(otherReset) : [];
      for (let key in form) {
        if (keys.includes(key)) {
          form[key] = otherReset[key];
        } else {
          form[key] = null;
        }
      }
    },

    // 刷新列表
    reflash(flag) {
      const { topicName, topicType, isEnable } = this.form;
      let params = {
        topicName,
        topicType,
        isEnable,
        pageNum: this.form.pageNum,
      };
      this.getList(params, flag);
    },

    //查询重置
    btnOperation(type) {
      switch (type) {
        case "search":
          this.form.pageNum = 1;
          this.reflash();
          break;
        case "reload":
          // this.reset(this.form);
          this.form = {
            topicName: '',
            queType: undefined,
            pageNum: 1,
            pageSize: 10,
          }
          this.getList(); //重新获取数据
          break;
      }
    },

    // 点击编辑问卷模板
    setTemplate(e, enter) {
      this.$router.push({
        name: "quesTemplateEdit",
        query: {
          id: e.id,
          enter: enter
        },
      });
    },

    // 点击预览问卷模版
    previewTemplate(e, enter) {
      this.$router.push({
        name: "quesTemplatePreview",
        query: {
          id: e.id,
          enter: enter
        },
      });
    },
  },
  created() {
    this.getQueTypeArr()
    this.getList();
  },
};
</script>
<style lang='less' scoped>
::v-deep .filter-tree {
  padding: 10px 0;
}

::v-deep .filter-tree .el-tree-node>.el-tree-node__content:hover {
  background-color: rgba(24, 144, 255, .2);
}

::v-deep .filter-tree .el-tree-node.is-current>.el-tree-node__content {
  background-color: rgba(24, 144, 255, 1);
  color: #fff;
}

::v-deep .filter-tree .el-tree-node {
  margin: 0 0;
  padding: 3px 0;
}

::v-deep .filter-tree>.el-tree-node>.el-tree-node__content>.el-tree-node__label {
  font-weight: bold;
}

::v-deep .baseDropdownMenu.el-dropdown-menu--medium {
  width: 117px !important;
}

::v-deep .baseDropdownMenu li {
  width: 117px !important;
}

::v-deep .typeElForm .el-form-item__content {
  display: flex;
  align-items: center;
}

::v-deep .typeElForm .el-form-item__content .el-select {
  flex: 1;
}

.typeMesgBtn {
  color: #1890ff;
  font-size: 14px;
  margin-left: 10px;
  cursor: pointer;

  &:hover {
    opacity: .5;
  }
}

.newLine {
  width: 100%;
  display: inline-block;
  font-size: 12px;
  color: #999;
  line-height: 22px;
  margin-top: 10px;
}

.queTemplateDialog {
  .mainTemplate {
    border: 1px solid #ccc;
    width: 100%;
    display: flex;
    align-items: flex-start;
    height: 400px;
    position: relative;

    .leftTemp {
      width: 200px;
      box-sizing: border-box;
      padding: 0 10px;
      border-right: 1px solid #ccc;
      height: 100%;
      position: relative;

      .seach {
        margin-top: 10px;
        margin-bottom: 10px;
      }

      .conTemp {
        height: calc(100% - 66px);
        overflow-y: scroll;
      }
    }

    .rightTemp {
      flex: 1;
      width: 100%;
      height: 398px;
      position: relative;
      display: inline-block;
      overflow: hidden;
      padding: 1px;
      box-sizing: border-box;

      img {
        width: 100%;
      }
    }
  }
}

.bl_title {
  font-size: 16px;
  font-weight: bold;
  width: 100%;
  display: inline-block;
  margin-bottom: 20px;
}



::v-deep .flex {
  .ant-form-item {
    margin-bottom: 0;
    margin-right: 10px;
  }
}

::v-deep .hideLabel {
  .ant-form-item-label {
    opacity: 0;
  }
}

.tableTdControl {
  text-align: left;

  button,
  span {
    margin: 0 3px;
  }
}
</style>
